import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Play, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PlaylistEmptyStateProps {
  onCreatePlaylist: () => void;
}

export function PlaylistEmptyState({ onCreatePlaylist }: PlaylistEmptyStateProps) {
  useLanguage();
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 animate-fade-in">
      <div className="text-center space-y-6 max-w-md">
        {/* Ícone Premium com Gradiente */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-[#EFF6FF] flex items-center justify-center">
            <Play className="h-10 w-10 text-[#2563EB]" strokeWidth={1.5} />
          </div>
        </div>

        {/* Texto */}
        <div className="space-y-3">
          <h2 className="text-xl font-semibold text-[#0F172A]">
            {translateInterfaceText("Você ainda não criou playlists")}</h2>
          <p className="text-[#64748B] text-[15px] leading-relaxed">
            {translateInterfaceText("Organize seus vídeos em sequências e publique com 1 clique.")}</p>
        </div>

        {/* Botão CTA Premium */}
        <Button 
          onClick={onCreatePlaylist}
          className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 h-11 rounded-[10px] shadow-sm"
        >
          <Plus className="h-4 w-4 mr-2" />
          {translateInterfaceText("Criar Playlist")}</Button>
      </div>
    </div>
  );
}
